import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import type {
    GetAccountTypes_accountTypes as AccountType,
    GetAccountTypes as GetAccountTypesQuery,
} from 'nutshell-graphql-types';

import GET_ACCOUNT_TYPES from '../queries/get-account-types.graphql';

export const useGetAccountTypes = (): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    accountTypes: AccountType[];
} => {
    const {loading, data, error} = useQuery<GetAccountTypesQuery, Record<any, any>>(
        GET_ACCOUNT_TYPES,
        {
            fetchPolicy: 'cache-and-network',
            notifyOnNetworkStatusChange: true,
        }
    );

    return {
        isLoading: loading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        accountTypes: data && data.accountTypes ? data.accountTypes : [],
    };
};
